import { setAuthToken, getAuthToken, clearAuthToken } from "@app/relay/fetch-relay";

// The single Bearer slot (authToken) holds whichever principal is active:
// an admin token on the console, or a user/impersonation token in the app.
// cxRole disambiguates client-side; cxAdminBackupToken parks the admin token
// while impersonating so we can return to the console.
const ROLE_KEY = "cxRole";
const BACKUP_KEY = "cxAdminBackupToken";

export function loginAsAdmin(token: string) {
  setAuthToken(token);
  localStorage.setItem(ROLE_KEY, "admin");
}

export function isAdminSession() {
  return Boolean(getAuthToken()) && localStorage.getItem(ROLE_KEY) === "admin";
}

export function logoutAdmin() {
  clearAuthToken();
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(BACKUP_KEY);
}

export function startImpersonation(userToken: string) {
  const current = getAuthToken();
  if (current) localStorage.setItem(BACKUP_KEY, current);
  setAuthToken(userToken);
  localStorage.setItem(ROLE_KEY, "impersonating");
}

export function isImpersonating() {
  return localStorage.getItem(ROLE_KEY) === "impersonating";
}

export function exitImpersonation() {
  const backup = localStorage.getItem(BACKUP_KEY);
  if (backup) {
    setAuthToken(backup);
    localStorage.removeItem(BACKUP_KEY);
    localStorage.setItem(ROLE_KEY, "admin");
  }
}
